// extracted by mini-css-extract-plugin
export default {"divider":"TextDivider_divider__ZmI5H","bar":"TextDivider_bar__FPYYZ","text":"TextDivider_text__1sXVX"};